import { useSalesChannelContent } from 'src/hooks/useSalesChannelContent';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { get } from 'lodash';
import { useEffect, useRef } from 'react';
import {
  //useEffect, useRef,
  useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useForms } from './useForms';
import { useRequest } from 'ahooks';
import {
  getContent404Page_revamp,
  getContentButtonThemes,
  postContent404Page_revamp,
} from '@/src/request/salesChannel/content';
import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useCloneBtnParams } from '@/src/hooks/useCloneBtnParams';
import { checkAll } from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page-revamp/validator';
import { msg } from 'src/tools/message';
import { modal } from '@/src/utils/Modal';
import defaultData from '../default';
import sync from 'src/strategies/404';
import { EPreviewSize } from '@/src/types/common/SalesChannel';

const use404 = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    params,
    salesChannelMultiLanguageQueryParams,
    salesChannel,
    selectedLanguage,
    salesChannelMultiLanguageParams,
  } = useSalesChannelContent();
  const { pcForm, mobileForm, tabletForm } = useForms();
  const { saleChannelUuid, contentUuid } = params;

  const _history = useHistory();

  const [hasModified, setHasModified] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const copyOfOriginal = useRef<any>(null);
  const isLive =
    get(copyOfOriginal.current, 'salesChannelContent.status') === 'Live';

  const onGoBack = () => {
    _history.push(`/salesChannel/content/${saleChannelUuid}`);
  };

  const { data: buttons } = useRequest(() =>
    getContentButtonThemes(contentUuid),
  );

  const queryParams = salesChannelMultiLanguageQueryParams;
  const submitParams = salesChannelMultiLanguageParams;
  const currentLanguage = useQueryLanguageListContentEditor();
  const cloneParams = useCloneBtnParams();

  const handleOnDataGet = (data) => {
    copyOfOriginal.current = data;
    if (!data?.pc && !data?.tablet && !data?.mobile) {
      pcForm.setFieldsValue(defaultData.pc);
      tabletForm.setFieldsValue(defaultData.tablet);
      mobileForm.setFieldsValue(defaultData.mobile);
    } else {
      const pContentSetting = get(data, 'pc.contentSetting');
      const pButtonStyle = get(data, 'pc.buttonText');
      const pFeaturedProducts = get(data, 'pc.featuredProducts');

      pcForm.setFieldsValue({
        contentSetting: pContentSetting,
        buttonText: pButtonStyle,
        featuredProducts: pFeaturedProducts,
      });

      const tContentSetting = get(data, 'tablet.contentSetting');
      const tButtonStyle = get(data, 'tablet.buttonText');
      const tFeaturedProducts = get(data, 'tablet.featuredProducts');

      tabletForm.setFieldsValue({
        contentSetting: tContentSetting,
        buttonText: tButtonStyle,
        featuredProducts: tFeaturedProducts,
      });

      const mContentSetting = get(data, 'mobile.contentSetting');
      const mButtonStyle = get(data, 'mobile.buttonText');
      const mFeaturedProducts = get(data, 'mobile.featuredProducts');

      mobileForm.setFieldsValue({
        contentSetting: mContentSetting,
        buttonText: mButtonStyle,
        featuredProducts: mFeaturedProducts,
      });
    }
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
  };

  const handleOnSubmit = async () => {
    const pD = pcForm.getFieldsValue();
    const tD = tabletForm.getFieldsValue();
    const mD = mobileForm.getFieldsValue();
    const pR = checkAll(pD);
    const tR = checkAll(tD);
    const mR = checkAll(mD);
    console.log(pR, tR, mR);

    if (
      (!get(pR, 'hasError') &&
        !get(tR, 'hasError') &&
        !get(mR, 'hasError') &&
        isLive) ||
      !isLive
    ) {
      const data = {
        ...(copyOfOriginal.current || {}),
        pc: pD,
        tablet: tD,
        mobile: mD,
      };
      await onSubmit(data, submitParams);
      msg.success(getI18n('general.savesuccess'));
      setHasModified(false);
    } else {
      modal.error({
        title: getI18n('general.unabletosavechanges'),
        content: getI18n('general.fixerrors'),
        onOk: () => {
          return;
        },
      });
    }
  };

  const {
    // data,
    loading,
    run: _onFetch,
  } = useRequest(
    (queryParams) => {
      return getContent404Page_revamp(contentUuid, queryParams);
    },
    {
      manual: true,
      onSuccess: handleOnDataGet,
    },
  );

  const { run: onSubmit } = useRequest(postContent404Page_revamp, {
    manual: true,
    onSuccess: (d) => {
      handleOnDataGet(d);
    },
  });

  const onFetch = (queryParams) => {
    setLoaded(false);
    _onFetch(queryParams);
  };

  const handleReload = (queryParams) => {
    onFetch(queryParams);
  };

  useEffect(() => {
    onFetch(queryParams);
  }, [
    currentLanguage, //currentStyle, currentSize
  ]); //每次变化重新抓取数据

  const handleOnSectionCopy = (fields, breakpoint) => {
    return;
  };

  const handlePCFormValuesChange = (changeFields: Array<any>) => {
    setHasModified(true);
    sync(changeFields, { pcForm, tabletForm, mobileForm });
  };

  const handleCloneFromPrimaryLanguage = async () => {
    await onFetch(cloneParams);
    setHasModified(true);
  };
  const handleOnDiscard = async () => {
    if (hasModified) {
      //const data = submitData();
      //await handleAddDraft(selectedLanguage, data?.submitData);
    }
    onGoBack();
  };

  const handleOnReset = (fields: Array<any>, breakpoint) => {
    if (breakpoint === EPreviewSize.WIDE) {
      pcForm.setFields(
        fields.map((key) => {
          const v = get(defaultData.pc, key);
          return {
            name: key,
            value: v ? v : null,
          };
        }),
      );
    }

    if (breakpoint === EPreviewSize.TABLET) {
      tabletForm.setFields(
        fields.map((key) => {
          const v = get(defaultData.tablet, key);
          return {
            name: key,
            value: v ? v : null,
          };
        }),
      );
    }
    if (breakpoint === EPreviewSize.MOBILE) {
      mobileForm.setFields(
        fields.map((key) => {
          const v = get(defaultData.mobile, key);
          return {
            name: key,
            value: v ? v : null,
          };
        }),
        // .filter((v) => !!v),
      );
    }
  };

  const handleOnCopy = (fields: Array<any>, breakpoint) => {
    const pcValues = pcForm.getFieldsValue(true);
    if (breakpoint === EPreviewSize.TABLET) {
      tabletForm.setFields(
        fields.map((key) => {
          const v = get(pcValues, key);
          return {
            name: key,
            value: v,
          };
        }),
      );
    }
    if (breakpoint === EPreviewSize.MOBILE) {
      mobileForm.setFields(
        fields.map((key) => {
          const v = get(pcValues, key);
          return {
            name: key,
            value: v,
          };
        }),
      );
    }
  };

  return {
    salesChannel,
    selectedLanguage,
    hasModified,
    setHasModified,
    onGoBack,
    buttons,
    pcForm,
    mobileForm,
    tabletForm,

    loading,
    loaded,
    handleOnCopy,
    handleOnSubmit,
    handleOnReset,
    handleReload,
    handleOnSectionCopy,
    handlePCFormValuesChange,
    handleCloneFromPrimaryLanguage,
    handleOnDiscard,
    data: copyOfOriginal.current,
  };
};
export { use404 };
